import { disableJobById, enableJobById } from '@jobs/services/jobsServices';
import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

export const useEnableJob = () => {
  const useEnablJobMutation = useMutation<
    AxiosResponse<null>,
    unknown,
    { id: string },
    unknown
  >((mutationVariables) => enableJobById(mutationVariables.id));

  return useEnablJobMutation;
};

export const useDisableJob = () => {
  const useEnablJobMutation = useMutation<
    AxiosResponse<null>,
    unknown,
    { id: string },
    unknown
  >((mutationVariables) => disableJobById(mutationVariables.id));

  return useEnablJobMutation;
};
